import { render, staticRenderFns } from "./PurposeBlock.vue?vue&type=template&id=72af704e&"
import script from "./PurposeBlock.vue?vue&type=script&lang=js&"
export * from "./PurposeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports